/* Publish by EComposer at 2026-10-21 06:35:14*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2i58yaroc51"]=  window.__ectimmers["ecom-2i58yaroc51"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2i58yaroc51').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2i58yaroc51', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-deugpcw0o75').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-deugpcw0o75', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12pro502pw5d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12pro502pw5d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hyz5fpvyh6i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hyz5fpvyh6i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2prpbbouh5h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2prpbbouh5h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qchmf5uac1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qchmf5uac1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmxd755fxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmxd755fxl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yeeqmon7kz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yeeqmon7kz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tuds43n38t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tuds43n38t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1un2m2hmisn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1un2m2hmisn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3rq6mipcbp3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3rq6mipcbp3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8dbsmbcfj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8dbsmbcfj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w1js7dpaznn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w1js7dpaznn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fhrwh484yl8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fhrwh484yl8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6qvxy0myif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6qvxy0myif', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g3myl45zbv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g3myl45zbv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sq0epnvbe7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sq0epnvbe7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-whp8td3g4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-whp8td3g4g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6yxoyxexb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6yxoyxexb', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wmhi18dsdug"]=  window.__ectimmers["ecom-wmhi18dsdug"] || {};
const t=this.$el,e=this.settings.autoSlideHover;let i="";var n=!0;if(!t)return;const s=t.querySelector(".ecom-img_comp-slider");if(!s)return;const o=t.querySelector(".ecom-image_compare-overlay img"),a=t.querySelector(".ecom-image_comp-overlay");s.onmouseover=function(){r()},s.onmouseout=function(){n&&l()},s&&o&&c(),window.addEventListener("resize",function(){s&&o&&(i=o.offsetWidth,c())});function r(){a&&a.classList.add("overlay-hidden")}function l(){a&&a.classList.remove("overlay-hidden")}function c(){var d=0,m,g,_;b(),!e||window.screen.width<1024?(s.onmousedown=function(z){y(z)},t.onmouseup=function(){v()},s.ontouchstart=function(z){y(z)},t.ontouchend=function(){v()}):t.onmouseover=function(z){y(z)};function b(){s.style.left&&(i=o.offsetWidth,g=parseInt(s.style.left))}function y(z){n=!1,z.preventDefault(),z.clientX?m=z.clientX:m=z.touches[0].clientX,d=1,t.onmousemove=function(T){w(T)},t.ontouchmove=function(T){w(T)}}function v(){d=0,isNaN(_)||(g=_),n=!0,l()}function w(z){if(d==0)return!1;d==1&&r(),_=k(z),_<0&&(_=0),_>100&&(_=100),C(_)}function k(z){z=z.changedTouches?z.changedTouches[0]:z;var T;return!e||window.screen.width<1024?T=Math.round(g-(m-z.pageX)*100/i):T=Math.round(z.offsetX*100/i),T}function C(z){s.style.left=z+"%",o.style.clipPath=`polygon(${z}% 0%, ${z}% 100%, 0% 100%, 0% 0%)`}}

                    });
                    
                        document.querySelectorAll('.ecom-wmhi18dsdug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wmhi18dsdug', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-oqob5b6ddj"]=  window.__ectimmers["ecom-oqob5b6ddj"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-oqob5b6ddj"]["ysjhzln3n"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",s)}catch(r){console.error("[EC Tracking] Error publishing analytics event:",r)}const o=e.getAttribute("href"),a=e.getAttribute("target");o&&o!=="#"&&o!=="javascript:void(0)"&&(a==="_blank"?window.open(o,"_blank"):setTimeout(function(){window.location.href=o},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-oqob5b6ddj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqob5b6ddj', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}